import { createContext, useState } from 'react'
import ActivityCard from '../profile/ActivityCard';

const ProfileContext = createContext()

export const ProfileProvider = ({ children }) => {
   const [profileData, setProfileData] = useState({
      name: 'Firstname Lastname',
      username: 'gaggle',
      description:
         'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Vero laboriosam vitae facilis a! Ipsam odit quia sit recusandae beatae dolore porro accusamus animi dignissimos provident, dolores doloribus consectetur corrupti. Suscipit?',
      tags: {status: '', major: ''}, //status is the year (sophomore, junior, etc)
      profile_pic_src: 'https://webdev.cse.buffalo.edu/hci/api/uploads/files/6EPRcFi3zBYkArwbWs0fP-xurNdSCO9kIjGNA6lGiQ8.png'
   })
   const [isEditing, setIsEditing] = useState(false)


/*  Function:   getAllUserPosts()
    Purpose:    Gets the list of all users posts
    Returns:    Array containing all users posts
*/
async function getAllUserPosts() {
   const response = await fetch(
       'https://webdev.cse.buffalo.edu/hci/api/api/deekstra/posts?authorID=' 
       + sessionStorage.getItem("user") + '&sort=newest', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
   })
   // console.log(response);
   const responseObj = await response.json()
   // console.log(`User ID: ${sessionStorage.getItem("user")}`);
   // console.log(responseObj[1], responseObj[0]);
   if (responseObj[1]) return responseObj[0]
   else return null
}

/*  Function:   getGuestUsersPosts()
    Purpose:    Gets the list of all users posts
    Returns:    Array containing all users posts
*/
async function getGuestUsersPosts(id) {
   const response = await fetch(
       'https://webdev.cse.buffalo.edu/hci/api/api/deekstra/posts?authorID=' 
       + id + '&sort=newest', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
   })
   // console.log(response);
   const responseObj = await response.json()
   // console.log(`User ID: ${sessionStorage.getItem("user")}`);
   // console.log(responseObj[1], responseObj[0]);
   if (responseObj[1]) return responseObj[0]
   else return null
}

function getTimeNumeric() {
   let date = new Date()
   let hours = date.getHours()
   let minutes = date.getMinutes()
   let time = hours * 60 + minutes
   return time
}

function convertTimeNumeric(p) {
   // console.log(p);
   const time = p

   const timeIndex = time.indexOf(':') // : that separates hours from minutes

   if (timeIndex === -1) {
      // console.log(`Wrong schema format for post ${p.id} by author ${p.authorID}`);
      return null // String is in the wrong format
   }

   let hours = time.slice(0, timeIndex)
   let minutes = time.slice(timeIndex + 1, time.length)
   // console.log(`endTime: ${hours}:${minutes}`);

   let sum = parseInt(hours) * 60 + parseInt(minutes)
   return sum
}

function compareToToday(d) {
   if (!d) return false;
   let dateParts = d.split('/');
   let today = new Date();
   let day = today.getDate();
   let month = today.getMonth() + 1;
   let year = today.getFullYear();

   // console.log("\nDATE PARTS");
   // console.log(dateParts);
   // console.log(month, day, year);

   // If the years are not the same
   if (parseInt(dateParts[2] !== parseInt(year))) {
      if (parseInt(dateParts[2]) > parseInt(year)) return 'later'
      return 'earlier'
   } 
   // If the months are not the same
   else if (parseInt(dateParts[0]) !== parseInt(month)) {
      if (parseInt(dateParts[0]) > parseInt(month)) return 'later'
      return 'earlier'
   }
   // If the days are not the same
   else if (parseInt(dateParts[1]) !== parseInt(day)) {
      if (parseInt(dateParts[1]) > parseInt(day)) return 'later'
      return 'earlier'
   } else return 'same'
}

function filterNow(posts) {
   // console.log("FILTERING NOW");
   // console.log(posts);

   const currentTime = getTimeNumeric() // Get the current time
   const nowPosts = Promise.all(
      posts.filter((p) => {
         if (!p) return false
         // console.log("CHECK:", compareToToday(p));

         const endTime = convertTimeNumeric(p.attributes.endTime) // Get the post's ending time
         const startTime = convertTimeNumeric(p.attributes.startTime)
         // console.log('Times:', currentTime, endTime, startTime);
         if (compareToToday(p.attributes.date) === 'later') // If the start date is later than now, it's not happening yet
            return false;
         else if (compareToToday(p.attributes.date) === 'earlier') {    // If the start date is earlier than now, it may be a past event or a multiday event
            if (compareToToday(p.attributes.end_date) === 'earlier')     // If the end date is also earlier than now, the event is over
               return false;
            else if (compareToToday(p.attributes.end_date) === 'later')  // The end date is later, so the event is still ongoing
               return true;
            else if (compareToToday(p.attributes.end_date) === 'same') { // The end date is the same as today, so see if it's over
               return endTime > currentTime;  // If this post's ending time is later than the current time, add it to the nowPosts array
            }
            else {
               // console.log(`Error comparing dates, a string from database is in wrong format\n date: ${p.attributes.date}, endDate: ${p.attributes.endDate}`);
               return false;
            }
         }
         else if (compareToToday(p.attributes.date) === 'same') { // The start date is the same as today, the event could be ended, ongoing or upcoming
            if (compareToToday(p.attributes.end_date) === 'earlier') return false;   // End date is earlier than today, shouldn't be happening (invalid input)

            else if (compareToToday(p.attributes.end_date) === 'later')  // End date is later than today, so just check if the start time has passed
               return currentTime >= startTime;
            else if (compareToToday(p.attributes.end_date) === 'same')   // End date is the same as today, compare both the starting and ending times with today
               return endTime > currentTime && currentTime >= startTime   // If this post's ending time is later than the current time, add it to the nowPosts array
            else {
               // console.log(`Error comparing dates, a string from database is in wrong format\n date: ${p.attributes.date}, endDate: ${p.attributes.endDate}`);
               return false
            }
         }  
         else {
            console.log(`Error comparing dates, a string from database is in wrong format\n date: ${p.attributes.date}, endDate: ${p.attributes.endDate}`);
            return false
         }
      })
   )
   //console.log(nowPosts)
   return nowPosts
}

function filterUpcoming(posts) {
   // console.log("FILTERING UPCOMING");
   // console.log(posts);
   const currentTime = getTimeNumeric() // Get the current time
   const nowPosts = Promise.all(
      posts.filter((p) => {
         if (!p) return false
         const startTime = convertTimeNumeric(p.attributes.startTime) // Get the post's ending time
         // console.log('Times:', currentTime, startTime);

         if (compareToToday(p.attributes.date) === 'later') return true
         else if (compareToToday(p.attributes.date) === 'earlier') return false
         return startTime > currentTime // If this post's ending time is later than the current time, add it to the nowPosts array
      })
   )
   return nowPosts
}

function filterRecent(posts) {
   // console.log("FILTERING RECENT");
   // console.log(posts);
   const currentTime = getTimeNumeric() // Get the current time
   const nowPosts = Promise.all(
      posts.filter((p) => {
         if (!p) return false
         const endTime = convertTimeNumeric(p.attributes.endTime) // Get the post's ending time
         // console.log('Times:', currentTime, endTime);

         if (compareToToday(p.attributes.date) === 'earlier') return true
         else if (compareToToday(p.attributes.date) === 'later') return false
         return endTime <= currentTime // If this post's ending time is later than the current time, add it to the nowPosts array
      })
   )
   return nowPosts
}

   return <ProfileContext.Provider value = {{
      profileData,
      setProfileData,
      isEditing, 
      setIsEditing,
      getAllUserPosts,
      getTimeNumeric,
      convertTimeNumeric,
      compareToToday,
      filterNow,
      filterUpcoming,
      filterRecent,
      getGuestUsersPosts

   }}>
      {children}
   </ProfileContext.Provider>
}

export default ProfileContext